export enum ServiceOrderWorkflowActionType {
  PRINT_CUSTOMER_COPY = "PRINT_CUSTOMER_COPY",
  PRINT_WORK_ORDER = "PRINT_WORK_ORDER",
  EMAIL = "EMAIL",
  SMS = "SMS",
}
